import {Component, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {AuthenticationService} from '../../authenticationModule/services/authentication.service';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  passwordForm: UntypedFormGroup;
  invalidToken = false;
  token = '';
  passwordIsValid = false;
  error = false;
  passwordNotSecure = false;
  isResetPasswordPage: boolean;

  constructor(private authenticationService: AuthenticationService,
              private _formBuilder: UntypedFormBuilder) {
    this.isResetPasswordPage = location.href.includes('reset-password');
  }

  ngOnInit() {
    if (!!this.authenticationService.userAuthenticated) {
      Promise.resolve().then(() => this.authenticationService.logoutUser(false));
    }
    this.getTokenAndEmailFromUrl();
    this.checkResetPasswordTokenValidity();
    this.passwordForm = this._formBuilder.group({
      newPassword: ['', [Validators.required, Validators.min(8)]],
      confirmNewPassword: ['', Validators.required]
    });
  }

  private checkResetPasswordTokenValidity() {
    this.authenticationService.checkEmailAndTokenValidity(this.token, this.isResetPasswordPage).subscribe({
        next: () => {
        },
        error: () => {
          this.invalidToken = true;
        }
      }
    );
  }

  private getTokenAndEmailFromUrl() {
    this.token = this.isResetPasswordPage ?
      location.href.substring(location.href.indexOf('reset-password') + 15) :
      location.href.substring(location.href.indexOf('new-user-confirmation') + 22);
  }

  onSubmit() {
    if (this.passwordForm.invalid || !this.passwordIsValid) {
      return;
    }
    return this.changePassword();
  }

  changePassword() {
    this.authenticationService.resetPasswordWithToken(this.token, this.passwordForm.get('newPassword').value, this.isResetPasswordPage).subscribe({
        next: () => {
          this.error = false;
          this.passwordNotSecure = false;
          this.authenticationService.displayChangePasswordAlert = true;
          this.authenticationService.isLoginMode = true;
          location.assign('/#/');
        },
        error: error => {
          if (error.status === 401) {
            this.invalidToken = true;
          } else if (error.status === 417) {
            this.passwordNotSecure = true;
          } else {
            this.error = true;
          }
        }
      }
    );
  }

  showErrorMessage(fieldName: string): boolean {
    if (!this.passwordForm.controls[fieldName]) {
      return false;
    }
    return !this.passwordForm.controls[fieldName].valid;
  }

  setAuthenticationServiceIsLoading(isLoading: boolean) {
    this.authenticationService.isLoginMode = isLoading;
  }

  passwordValid(event) {
    this.passwordIsValid = event;
  }
}
